import { SyncStatus } from "@/components/sync";
import { useAppStore } from "@/store";
import { observer } from "mobx-react-lite";
import { MenuItem } from "react-aria-components";

export const SidebarDropdownSyncStatus = observer(function SidebarDropdownSyncStatus() {
  const { store } = useAppStore();
  const { syncState } = store.sync;
  return (
    <MenuItem>
      <SyncStatus syncState={syncState} />
    </MenuItem>
  );
});
